import { AxiosProgressEvent } from 'axios';
import * as React from 'react';
import { endpointFundDocumentsPOST } from '~/api/def/endpoints/fundEndpoint';
import {
  UploaderQueue,
  UploaderQueueRef,
} from '~/components/ui/uploaderQueue/UploaderQueue';

type DocumentUploaderProps = {
  fundId: string;
  portfolioCompanyId?: string;
  onSubmitComplete?: () => void;
};

export const DocumentUploaderQueue = ({
  fundId,
  portfolioCompanyId,
  onSubmitComplete,
}: DocumentUploaderProps) => {
  const ref = React.useRef<UploaderQueueRef>(null);
  const customBaseUploader = async (id: string, file: File) => {
    const response = await endpointFundDocumentsPOST(
      fundId,
      {
        documents: [file],
      },
      portfolioCompanyId || undefined,
      (progressEvt: AxiosProgressEvent) => {
        if (ref.current) {
          ref.current.setProgress({
            id,
            progress: Math.round(
              (progressEvt.loaded / (progressEvt.total || 1)) * 100,
            ),
          });
        }
      },
    );
    if (ref.current && response) {
      if (response.status === 200) onSubmitComplete && onSubmitComplete();

      // Handle error response
      if (response.status !== 200 && response.data) {
        const errorData = response.data as unknown as
          | {
              message: string;
              type: string;
            }
          | undefined;
        ref.current.setComplete({
          id,
          code: response.status,
          error: response.statusText,
          errorMessage: errorData?.message || response.statusText,
          errorType: errorData?.type || 'UploadError',
        });
      } else {
        ref.current.setComplete({
          id,
          code: response.status,
          error: response.statusText,
        });
      }
    }
  };

  return (
    <div>
      <UploaderQueue ref={ref} fileUploadFn={customBaseUploader} />
    </div>
  );
};
